import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [dialog, setDialog] = useState({ open: false, mode: "register", inviteCode: "", cardKey: "" });

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("hy_token");
    if (!t) {
      setUser(null);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("hy_token");
      setUser(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    if (data.requires_2fa) {
      return { requires_2fa: true, pre_token: data.pre_token };
    }
    localStorage.setItem("hy_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login2fa = async (preToken, code) => {
    const { data } = await api.post("/auth/login/2fa", { pre_token: preToken, code });
    localStorage.setItem("hy_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("hy_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("hy_token");
    setUser(null);
  };

  const openAuth = (opts = {}) =>
    setDialog({ open: true, mode: opts.mode || "register", inviteCode: opts.inviteCode || "", cardKey: opts.cardKey || "" });
  const closeAuth = () => setDialog((d) => ({ ...d, open: false }));

  return (
    <AuthCtx.Provider value={{ user, ready, dialog, openAuth, closeAuth, login, login2fa, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
